var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIconBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8473_33290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2199 26.0822C22.2174 26.0822 23.8183 27.6987 23.8183 29.7103V34.5397C23.8183 36.5372 22.2174 38.1664 20.2199 38.1664H15.4316C13.4483 38.1664 11.8333 36.5372 11.8333 34.5397V29.7103C11.8333 27.6987 13.4483 26.0822 15.4316 26.0822H20.2199ZM36.5684 26.0822C38.5517 26.0822 40.1667 27.6987 40.1667 29.7103V34.5397C40.1667 36.5372 38.5517 38.1664 36.5684 38.1664H31.7801C29.7826 38.1664 28.1817 36.5372 28.1817 34.5397V29.7103C28.1817 27.6987 29.7826 26.0822 31.7801 26.0822H36.5684ZM36.5684 9.8335C38.5517 9.8335 40.1667 11.4627 40.1667 13.4616V18.291C40.1667 20.3027 38.5517 21.9177 36.5684 21.9177H31.7801C29.7826 21.9177 28.1817 20.3027 28.1817 18.291V13.4616C28.1817 11.4627 29.7826 9.8335 31.7801 9.8335H36.5684Z",
    fill: "url(#paint0_linear_8473_33290)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8473_33290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8183 13.4616C23.8183 11.4627 22.2175 9.8335 20.22 9.8335H15.4316C13.4483 9.8335 11.8333 11.4627 11.8333 13.4616V18.291C11.8333 20.3027 13.4483 21.9177 15.4316 21.9177H20.22C22.2175 21.9177 23.8183 20.3027 23.8183 18.291V13.4616Z",
    fill: "url(#paint1_linear_8473_33290)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8473_33290",
    x: 0.833252,
    y: 0.833496,
    width: 56.3335,
    height: 56.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.347833 0 0 0 0 0.241667 0 0 0 0 1 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8473_33290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8473_33290",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8473_33290",
    x: 0.833313,
    y: 0.833496,
    width: 39.985,
    height: 40.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.347833 0 0 0 0 0.241667 0 0 0 0 1 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8473_33290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8473_33290",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8473_33290",
    x1: 26,
    y1: 9.8335,
    x2: 26,
    y2: 38.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8454EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8473_33290",
    x1: 11.8333,
    y1: 15.8756,
    x2: 23.8183,
    y2: 15.8756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F5A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D9F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconBottom);
export default __webpack_public_path__ + "static/media/HomeIconBottom.cebbea4fbbdbcf7595439b128540b80d.svg";
export { ForwardRef as ReactComponent };